export * from "./archive.config";
export * from "./finance.config";
export * from "./knowledge.config";
export * from "./netfile.config";
export * from "./contract.config";
export * from "./default.config";
export * from "./authority.config";
export const DELETE_HINT = { title: "删除提示", message: "确认删除吗" };
export * from "./wx.config";

export enum TABS {
  CLIENT = "客户",
  NETFILE = "报税",
  FINANCE = "财务",
  INVOICE = "发票",
  CONTRACT = "合同",
  KNOWLEDGE = "知识库",
  ARCHIVE = "文档",
}
